import styled from "styled-components";

const PaginationContainer = styled.div.attrs({ className: "text-center" })``;

export default PaginationContainer;
